import { smellsLikeAPromise } from './smellsLikeAPromise';

export type Transformable<T> = T | Promise<T> | (() => T) | (() => Promise<T>);

export const normalizeTransformable = <K extends object>(data: Transformable<K>): Promise<K> => {
    if (smellsLikeAPromise(data)) {
        return Promise.resolve(data as Promise<K>);
    }

    if ('function' === typeof data) {
        return normalizeTransformable((data as (() => K) | (() => Promise<K>))());
    }

    return Promise.resolve(data as K);
};
